import { render, staticRenderFns } from "./Injury.vue?vue&type=template&id=05bc60fa&scoped=true&"
import script from "./Injury.vue?vue&type=script&lang=js&"
export * from "./Injury.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bc60fa",
  null
  
)

export default component.exports